var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureDocUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 512 512",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,512) scale(0.1,-0.1)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2510 4901 c-14 -4 -39 -15 -55 -24 -17 -8 -330 -316 -697 -684 -608     -609 -667 -672 -678 -713 -43 -163 89 -305 250 -270 l55 12 475 474 c261 261     479 474 483 474 4 0 7 -614 7 -1365 0 -1324 1 -1367 19 -1403 85 -166 315     -160 385 10 14 33 16 190 16 1398 0 748 3 1360 7 1360 4 0 222 -213 483 -474     l475 -474 55 -12 c161 -35 293 107 250 270 -11 41 -70 104 -678 713 -376 377     -683 677 -704 688 -44 23 -112 32 -148 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 2338 c-62 -17 -125 -81 -144 -144 -23 -79 -15 -1064 9 -1165 96     -398 372 -686 752 -784 132 -34 237 -36 1645 -32 1516 4 1421 0 1591 58 279     94 523 335 622 613 59 169 59 168 64 726 5 583 5 593 -58 664 -95 107 -264 91     -336 -32 l-28 -47 -5 -540 c-6 -523 -6 -542 -27 -598 -76 -201 -203 -325 -403     -393 -53 -18 -114 -19 -1490 -19 -1381 0 -1437 1 -1490 19 -124 42 -220 107     -297 198 -47 56 -108 187 -122 262 -7 38 -11 243 -11 557 l0 497 -28 53 c-46     89 -149 134 -244 107z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureDocUploadIcon);
export default __webpack_public_path__ + "static/media/secure-doc-upload-icon.94f38786f4d3c8956e0d48730dee90ad.svg";
export { ForwardRef as ReactComponent };